import { generateSlug } from "@/helpers/slugHelper";
import React, { useEffect, useState } from "react";
import styles from "../../ProductInfo/ProductInfo.module.scss";
/* This component will be use for Showing Product information  
   Vendor of the product and Name(title) of the product. 
*/

export default function GiftProductInfo({
  productInfo,
}) {
  const [vendor,setVendor] = useState()

    useEffect(()=>{
      if(productInfo){
        async function getVendorName(){
          const vendorName =  await generateSlug(productInfo.vendor)
          setVendor(vendorName)
        }
        getVendorName()
      }
    },[])
  if (productInfo) {
    return (
      <>
        <div className="grid-xs-9 grid-sm-9 grid-md-9 swatches-disabled">
          <h1 className="font-unset">
                <div id="designerName" className={`x-large-xs large-sm xx-large-md ${styles.heading}`}>
                  {productInfo.vendor}
                </div>
              <span
                id="productName"
                className={`small-xs normal-sm large-md ${styles.sub_heading}`}
              >
                {productInfo.title}
              </span>
          </h1>
          <div id="attn-inline-price-trigger"></div>
        </div>
      </>
    );
  }
}
